import { rendererLog } from 'js/shared/lib/CloudRenderer';

export const appUrl = () => {
  let url =
    import.meta.env.VITE_APPLICATION_URL_OVERRIDE ??
    `${window.location.origin}${import.meta.env.VITE_ASSET_PATH}`.replace(/\/$/, '');

  // TODO: Remove this when the pixi v8 players is 100% rolled out
  url += `?feature-rollout-enabled=true`;
  rendererLog('App URL:', url);

  return url;
};
